import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import {Router, ActivatedRoute} from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SidebarComponent } from '../sidebar/sidebar.component';

declare var $: any;
declare var Nanobar: any;
// declare var firebase: any;
// declare var context: any;

@Component({
  providers: [SidebarComponent],
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  nao = new Nanobar();
  username: any;
  password: any;
  mystorage: any;
  pushToken: any;
  errorLoginMessage: any;
  userData: any;
  userToken: any;
  userMessage: any;
  userName: any;
  userSuccess: any;
  userRole: any;
  constructor(private router: Router, private authService: AuthenticationService, private localStorage: AsyncLocalStorage, private sidebar: SidebarComponent) {
    if (window.localStorage.getItem('isauthenticated') === 'true') {
      router.navigate(['dashboard']);
    }
  }
  pushNotificationFunction() {
    this.authService.pushNotify(window.localStorage.getItem('token'), this.authService.tokePush).subscribe(
      (data) => {
        console.log('pushNotificationFunction', data);
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  loginFunction() {
    var scope = this;
    this.nao.go(30);
    //console.log('login data');
    this.authService.login(this.username, this.password).subscribe(
      (data) => {
        //console.log('login data', data);
        this.nao.go(100);
        this.userData = data;
        this.userMessage = this.userData.message;
        this.userName = this.userData.first_name;
        this.userToken = this.userData.auth_token;
        this.userSuccess = this.userData.success;
        this.userRole = this.userData.roles;
        //console.log('success chk', this.userSuccess);
        if (this.userSuccess === true) {
          window.localStorage.setItem('isauthenticated', 'true');
          window.localStorage.setItem('token', this.userToken);
          window.localStorage.setItem('displayName', this.userName);
          window.localStorage.setItem('userRoles', JSON.stringify(this.userRole));
          this.sidebar.ngOnInit();
              // push notification
              this.pushNotificationFunction();
              console.log(this.userRole);
              if(this.userRole[0] === 2) {
                this.router.navigate(['dashboard']);
              }
              else if(this.userRole[0] === 3) {
                this.router.navigate(['/customers']);
              }
              else if(this.userRole[0] === 4) {
                this.router.navigate(['/drivers']);
              }
              else if(this.userRole[0] === 5) {
                this.router.navigate(['/order-request']);
              }
              else if(this.userRole[0] === 6) {
                this.router.navigate(['/order-listing']);
              }
              else if(this.userRole[0] === 7) {
                this.router.navigate(['/categories']);
              }
              else if(this.userRole[0] === 8) {
                this.router.navigate(['/business-categories']);
              }
              else if(this.userRole[0] === 9) {
                this.router.navigate(['/vendors']);
              }
              else if(this.userRole[0] === 10) {
                this.router.navigate(['/dispensaries']);
              }
              else if(this.userRole[0] === 11) {
                this.router.navigate(['/story']);
              }
              else if(this.userRole[0] === 12) {
                this.router.navigate(['/packges']);
              }
              else if(this.userRole[0] === 13) {
                this.router.navigate(['/store']);
              }
              else if(this.userRole[0] === 14) {
                this.router.navigate(['/support']);
              }
              else if(this.userRole[0] === 15) {
                this.router.navigate(['/billing']);
              }
              else if(this.userRole[0] === 16) {
                this.router.navigate(['/payments']);
              }
              else if(this.userRole[0] === 17) {
                this.router.navigate(['/withdraw']);
              }
              else if(this.userRole[0] === 18) {
                this.router.navigate(['/logs']);
              }
              else if(this.userRole[0] === 19) {
                this.router.navigate(['/events']);
              }
              else if(this.userRole[0] === 20) {
                this.router.navigate(['/faqs']);
              }
              else if(this.userRole[0] === 21) {
                this.router.navigate(['/settings']);
              }
              else if(this.userRole[0] === 22) {
                this.router.navigate(['/business-roles']);
              }
              else {
                this.router.navigate(['']);
              }
        } else {
            this.errorLoginMessage = this.userMessage;
        }
      },
      (error) => {
        this.nao.go(100);
        //console.log('error', error);
      }
    );
  }
  ngOnInit() {
    $('.header').css('display', 'none');
    $('.footer').css('display', 'none');
    $('#sidebar').css('display', 'none');
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts